import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';

import './styles.css';
import { App } from './app/App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initI18n } from '@talk2nick/i18n';
import { initFirebase } from '@talk2nick/shared';
import {
  applyPendingUpdateOnStart,
  dismissUpdateBanner,
  notifyUpdateAvailable,
  setRegistration,
  setUpdateHandlers,
  setupAutoUpdateChecker,
} from './features/pwa/updateStore';

// 로케일 초기화 (ko/en 동봉, 나머지 지연 로드)
initI18n();

// Firebase 초기화 — 실패해도 앱 셸은 렌더되도록 한다 (오프라인 허용)
try {
  initFirebase();
} catch (error) {
  console.error('[talk2nIcK] Firebase 초기화 실패:', error);
}

const container = document.getElementById('root');
if (!container) throw new Error('#root 요소를 찾을 수 없습니다.');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);

/**
 * 서비스워커 등록 및 실시간 업데이트 감지 (아이폰, 안드로이드 PWA, 맥북, 윈도우 무관).
 *
 * 자동 활성화(silent)는 채팅 화면을 도중에 새로고침해 작성 중인 메시지를
 * 날리므로 쓰지 않는다. 대신 새 버전이 감지되면 배너로 버전 정보와 함께 알리고,
 * 사용자가 "지금 업데이트"를 누를 때 활성화한다.
 */
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    notifyUpdateAvailable();
  },
  onOfflineReady() {
    console.info('[talk2nIcK] 오프라인 모드 준비 완료');
  },
  onRegisteredSW(_swUrl, r) {
    if (r) {
      setRegistration(r);
      setupAutoUpdateChecker(r);
    }
  },
});

setUpdateHandlers(updateSW, dismissUpdateBanner);

// SW 등록 전이거나 SW 미지원 브라우저에서도 실시간 버전 감지 폴러 가동
setupAutoUpdateChecker();

// 렌더링은 유지한 채로 활성화한다 — 지금 화면에 입력 중인 내용이 없으므로
// 새로고침해도 손실이 없다. 이 시점에만 자동 적용해 "열면 최신"을 보장한다.
void applyPendingUpdateOnStart();
